module.exports = __webpack_public_path__ + "media/images/countryrect/it-775bc02504cbca55dcbc7c0f6dca8fff.svg";